import React, { useEffect, useId, useRef, useState } from "react";

export default function DynamicGallerySection({ data }) {
  const titleId = useId();
  const [activeImage, setActiveImage] = useState(null);
  const closeButtonRef = useRef(null);
  const openerRef = useRef(null);

  useEffect(() => {
    if (!activeImage) return undefined;

    const handleKeyDown = (event) => {
      if (event.key === "Escape") setActiveImage(null);
    };

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    closeButtonRef.current?.focus();
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = previousOverflow;
      openerRef.current?.focus();
    };
  }, [activeImage]);

  if (!data?.columns?.length) return null;

  return (
    <>
      <section className="dynamic-gallery-section" aria-labelledby={titleId}>
        <div className="container">
          <div className="dynamic-gallery-heading text-center">
            <span className="main-title">{data.eyebrow}</span>
            <h2 className="heading" id={titleId}>{data.title}<br />{data.titleSecondLine}</h2>
          </div>
          <div className="row dynamic-gallery-grid">
            {data.columns.map((items, index) => (
              <div className="col-md-4 dynamic-gallery-column" key={index}>
                {items.map((item) => (
                  <figure className="dynamic-gallery-frame" key={item.image}>
                    <button
                      className="dynamic-gallery-image-button"
                      type="button"
                      onClick={(event) => {
                        openerRef.current = event.currentTarget;
                        setActiveImage(item);
                      }}
                      aria-label={`View ${item.imageAlt || "gallery image"} in large size`}
                    >
                      <img src={item.image} alt={item.imageAlt} width="568" height={item.height} loading="lazy" />
                      <span className="dynamic-gallery-expand-icon" aria-hidden="true">
                        <i className="fa-solid fa-up-right-and-down-left-from-center" />
                      </span>
                    </button>
                  </figure>
                ))}
              </div>
            ))}
          </div>
        </div>
      </section>
      {activeImage && (
        <div
          className="dynamic-gallery-lightbox"
          role="presentation"
          onMouseDown={(event) => {
            if (event.target === event.currentTarget) setActiveImage(null);
          }}
        >
          <div className="dynamic-gallery-lightbox-dialog" role="dialog" aria-modal="true" aria-label={activeImage.imageAlt || "Gallery image"}>
            <button ref={closeButtonRef} className="dynamic-gallery-lightbox-close" type="button" onClick={() => setActiveImage(null)} aria-label="Close image viewer">
              <span aria-hidden="true">&times;</span>
            </button>
            <img className="dynamic-gallery-lightbox-image" src={activeImage.image} alt={activeImage.imageAlt} />
          </div>
        </div>
      )}
    </>
  );
}
